// =============================================
// SERVICIO DE ESTADÍSTICAS
// =============================================

import api from './api';

const statsService = {
  // Obtener estadísticas generales (KPIs)
  getSummary: async () => {
    const response = await api.get('/stats/summary');
    return response.data;
  },

  // Obtener datos para gráfica de ingresos vs gastos
  getIncomeExpenses: async () => {
    const response = await api.get('/stats/income-expenses');
    return response.data;
  },

  // Obtener distribución de gastos por categoría
  getExpensesByCategory: async () => {
    const response = await api.get('/stats/expenses-category');
    return response.data;
  },

  // Obtener evolución de morosidad
  getDelinquencyTrend: async () => {
    const response = await api.get('/stats/delinquency-trend');
    return response.data;
  },

  // Obtener top 5 morosos
  getTopDebtors: async () => {
    const response = await api.get('/stats/top-debtors');
    return response.data;
  },
};

export default statsService;
